<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <v-row dense>
              <v-col cols="12">
                <strong>Overview Master Call Plan</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row class="mt-4">
              <v-col cols="3" md="3">
                <v-autocomplete
                  @change="filterDataTable"
                  v-model="branch"
                  :items="branchList"
                  item-text="BRANCH_CODE"
                  label="Branch"
                  color="red darken-1"
                  outlined
                  dense
                ></v-autocomplete>
                <!-- <v-autocomplete
                  @change="filterDataTable"
                  v-model="branch"
                  :items="branchList"
                  item-text="BRANCH_CODE"
                  :disabled="!isSuperUser"
                  label="Branch"
                  color="red darken-1"
                  outlined
                  dense
                ></v-autocomplete> -->
              </v-col>
              <v-col cols="3" md="3">
                <v-autocomplete
                  @change="filterDataTable"
                  v-model="position"
                  :items="positionList"
                  item-text="POSITION_DESC"
                  label="Position"
                  color="red darken-1"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" md="3">
                <v-autocomplete
                  @change="filterDataTable"
                  v-model="year"
                  :items="yearList"
                  item-text="YEARID"
                  label="Year"
                  color="red darken-1"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="3" md="3">
                <v-autocomplete
                  @change="filterDataTable"
                  v-model="periode"
                  :items="periodeList"
                  item-text="PERIODE"
                  label="Periode"
                  color="red darken-1"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" md="3">
                <!-- <v-text-field color="red darken-1"
                  v-model="position"
                  label="Position"
                  required
                  dense
                ></v-text-field>
                <v-btn
                  @click="filterDataTable"
                  outlined
                  color="indigo lighten-1"
                  :disabled="dtLoading"
                  >Load List</v-btn
                >-->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    <v-btn
                      class="ml-2"
                      @click="downloadCSV()"
                      outlined
                      color="indigo lighten-1"
                      :disabled="dtLoading"
                      >Export Data</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="dtHeaders"
                    :items="dtItems"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                  >
                    <template v-slot:item.edit="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item.ROLE_MAP_ID)"
                        >mdi-pencil</v-icon
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<style>
thead.v-data-table-header > tr > th > div {
  display: inline-block;
  width: 90%;
}

thead.v-data-table-header > tr > th > div.v-input label {
  font-size: 12px;
}
</style>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "YEARID",
    align: "start",
    value: "YEARID",
  },
  {
    text: "PERIODE",
    value: "PERIODE",
  },
  {
    text: "BRANCH CODE",
    value: "BRANCH_CODE",
  },
  {
    text: "POSITION DESC",
    value: "POSITION_DESC",
  },
  {
    text: "TYPE SALESMAN",
    value: "TYPE_SALESMAN",
  },
  {
    text: "CUSTOMERID_REF",
    value: "CUSTOMERID_REF",
  },
  {
    text: "CUSTOMER_NAME",
    value: "CUSTOMER_NAME",
  },
  {
    text: "PIC NAME",
    value: "PIC_NAME",
  },
  {
    text: "PIC TELP",
    value: "PIC_TELP",
  },
  {
    text: "MONDAY",
    value: "MONDAY",
  },
   {
    text: "TUESDAY",
    value: "TUESDAY",
  },
  {
    text: "WEDNESDAY",
    value: "WEDNESDAY",
  },
  {
    text: "THURSDAY",
    value: "THURSDAY",
  },
  {
    text: "FRIDAY",
    value: "FRIDAY",
  },
  {
    text: "SATURDAY",
    value: "SATURDAY",
  },
  {
    text: "NOTES",
    value: "NOTES",
  },
  //   {
  //     text: "Edit",
  //     value: "edit",
  //     sortable: false,
  //   },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      periodeList: [],
      positionList: [],
      yearList: [],
      branch: "ALL BRANCH",
      position: "NONE",
      periode: "NONE",
      year: "NONE",
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      isSuperUser:
        JSON.parse(localStorage.getItem("userData")).ORG_ID == 81 ? true : false,
    };
  },
  mounted() {
    const data = JSON.parse(localStorage.getItem("userData"))
    const orgID = JSON.parse(localStorage.getItem("userData")).ORG_ID;
    this.loadBranchList(orgID);
    //this.loadBranchListAll(orgID);
  },
  methods: {
    loadBranchListAll(orgID) {
      this.isLoading = true;
      this.$http
        .get("/structure/role/getBranchList", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.isLoading = false;
          let { data } = res.data;
       
          data.unshift({
            ORG_ID: -1,
            BRANCH_CODE: "ALL BRANCH",
            BRANCH_DESC: "ALL BRANCH",
          });
          this.branch = data[0];
          var newArray = data.filter(function (el) {
              return el.ORG_ID == orgID
          });
          this.branchList = newArray;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.toString());
        });
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItems);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Overview Master Call.xlsx"); // initiate a file download in browser
    },
    loadBranchList(orgID) {
      console.log('orgID ', orgID)
      this.isLoading = true;
      this.$http
        .post("/call-management/prepareFilterOverviewMasterCall", { orgID: orgID }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          let { data } = res.data;       
         
          if (orgID != 81) {
            this.branch = data.BRANCH_LIST[0].BRANCH_CODE;
          }
          console.log('data ', data)
          this.branchList = data.BRANCH_LIST;
          this.periodeList = data.PERIODE;
          this.positionList = data.POSITION;
          this.yearList = data.YEAR;
          this.filterDataTable();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.toString());
        });
    },
    filterDataTable() {
      this.dtLoading = true;
      const data = {
        branchCode: this.branch,
        position: this.position,
        year: this.year,
        periode: this.periode,
        orgID: JSON.parse(localStorage.getItem("userData")).ORG_ID,
      };
      this.$http
        .post("/call-management/overviewmastercall", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          let { data } = res.data;
          console.log('data ', data)
          if (data == null) {
            this.dtLoading = false;
            this.dtItems = [];
            this.showSnackbar("Data tidak ditemukan.");
          } else {
            this.dtLoading = false;
            this.dtItems = data;
          }
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    editItem(roleMapId) {
      this.$router.push({
        path: `/manage-role/new/${roleMapId}`,
      });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
